import { ServiceStatus } from '@app/services/enums/service-status.enum';

export class PosthogUtils {
    public static getServiceStatusValue(status: ServiceStatus): string {
        switch (status) {
            case ServiceStatus.InfoRequested:
                return 'Info Requested';
            case ServiceStatus.ReadyToSubmit:
                return 'Ready To Submit';
            case ServiceStatus.Submitted:
                return 'Submitted';
            default:
                return null;
        }
    }

    public static getErrorMessage(error: any): string {
        return error.errorCode || error.error;
    }
}
